import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;

export const FullContainer = styled(Container)`
    position: relative;
    flex-direction: row;
    gap: 0.5rem;
    align-items: flex-end;
`;

export const CompanyLogo = styled.img`
    max-width: 4rem;
    max-height: 4rem;
    border-radius: 0.5rem;
`;

export const LabelContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
`;

export const InputContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #efefef;
    border-radius: 0.25rem;
    padding: 0.5rem 1rem;
    border: 1px solid #ddd;

    input {
        width: 100%;
        border: none;
        background-color: transparent;
        color: #000;
    }
`;

export const TextAreaContainer = styled.div`
    width: 100%;
    min-height: 380px;
    max-height: 380px;
    display: flex;
    flex-direction: column;
    background-color: #efefef;
    border-radius: 0.25rem;
    padding: 0 1.5rem;
    overflow-y: scroll;
    border: 1px solid #ddd;

    * {
        color: #343434;
    }

    &::-webkit-scrollbar {
    background: transparent;
    border-radius: 8px;
    width: 0.25rem;
    margin: 1rem;
    height: 0.25rem;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: #98989c;
    border-radius: 0.5rem;
  }
`;